import React, { useState, useEffect, useRef } from "react";
import "../dashboard/dashboard.css";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Switch,
  Typography,
  Box,
  Grid,
  Tooltip,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  List,
  ListItem,
  ListItemText,
  CircularProgress,
  Divider,
  TextField,
} from "@mui/material";
import { useAuth } from "app/hooks/useAuth";
import { useNavigate } from "react-router-dom";
import { PATH } from "../../../config";
import { toast } from "react-toastify";
// import Loading from "app/components/MatxLoading";
import Loading from "app/components/MatxLoading";
import {
  startBreak,
  endBreak,
  checkInNow,
  checkOutNow,
} from "app/redux/actions";
import { useDispatch } from "react-redux";
import {
  dismissUserAnnouncements,
  getDashboard,
  getUserAnnouncements,
  getNotCheckedInUsers,
  getUsersOnBreak,
} from "app/redux/api";
import { capitalizeFirstLetter } from "app/assets/genericActions";
import { createOvertimeRequest } from "app/redux/actions/overtimeActions";
import {
  Error,
  EventAvailable,
  HolidayVillage,
  Notifications,
} from "@mui/icons-material";
import styled from "styled-components";
import CloseIcon from "@mui/icons-material/Close";
import HourglassBottomIcon from "@mui/icons-material/HourglassBottom";
import dayjs from "dayjs";

const formatTimeForDisplay = (dateTimeString) => {
  if (!dateTimeString) return "N/A";
  return new Date(dateTimeString).toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
};

const formatBreakDuration = (totalSeconds) => {
  if (isNaN(totalSeconds) || totalSeconds < 0) return "0h 0m 0s";

  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  return `${hours}h ${minutes}m ${seconds}s`;
};

const StatusCard = ({ stats, onStatusChange, liveWorkingHoursToday }) => {
  const dispatch = useDispatch();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [openWarningModal, setOpenWarningModal] = useState(false);
  const [checkoutMessage, setCheckoutMessage] = useState("");

  const performCheckout = () => {
    setOpenWarningModal(false);
    setIsSubmitting(true);
    dispatch(checkOutNow())
      .then(() => onStatusChange())
      .catch(() => {})
      .finally(() => setIsSubmitting(false));
  };

  const handleActionClick = () => {
    if (
      stats?.todayAttendanceDetails?.rawCheckIn &&
      !stats?.todayAttendanceDetails?.rawCheckOut
    ) {
      const totalWorkingMinutes = Math.floor(liveWorkingHoursToday * 60);
      const targetMinutes = 8 * 60;
      if (totalWorkingMinutes < targetMinutes) {
        setCheckoutMessage(
          "You have not completed 8 working hours. Are you sure you want to check out?"
        );
      } else {
        setCheckoutMessage("Are you sure you want to check out for the day?");
      }
      setOpenWarningModal(true);
    } else {
      setIsSubmitting(true);
      dispatch(checkInNow())
        .then(() => onStatusChange())
        .catch(() => {})
        .finally(() => setIsSubmitting(false));
    }
  };

  const getStatusDetails = () => {
    if (
      stats?.todayAttendanceDetails === null ||
      !stats?.todayAttendanceDetails?.rawCheckIn
    ) {
      return {
        title: "Not Checked In",
        buttonText: "Check In",
        showButton: false,
      };
    }

    const { rawCheckIn, rawCheckOut } = stats.todayAttendanceDetails;
    if (rawCheckOut === null) {
      return {
        title: dayjs(rawCheckIn).format("hh:mm A"),
        buttonText: "Check Out",
        showButton: true,
      };
    }
    return {
      title: dayjs(rawCheckOut).format("hh:mm A"),
      buttonText: "Checked Out",
      showButton: false,
    };
  };

  const statusDetails = getStatusDetails();

  return (
    <>
      <Box
        sx={{
          border: "1px solid #ccc",
          borderRadius: "8px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          height: "150px",
          boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
          backgroundColor: "#ffffff",
          padding: "20px",
        }}
      >
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Typography
            variant="body1"
            sx={{ color: "#757878", fontSize: "16px" }}
          >
            Status
          </Typography>
          <Typography sx={{ color: "#323232", fontSize: "16px" }}>
            {statusDetails.buttonText === "Check Out"
              ? "Checked-In"
              : statusDetails.buttonText === "Check In"
              ? ""
              : "Checked-Out"}
          </Typography>
        </Box>

        <Box
          sx={{
            mt: 2,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-end",
          }}
        >
          <Typography variant="h5" sx={{ color: "#323232" }}>
            {statusDetails.title}
          </Typography>
          {statusDetails.showButton && (
            <Button
              variant="contained"
              onClick={handleActionClick}
              disabled={isSubmitting}
              sx={{ borderRadius: "10px" }}
            >
              {statusDetails.buttonText}
            </Button>
          )}
        </Box>
      </Box>

      <Dialog
        open={openWarningModal}
        onClose={() => setOpenWarningModal(false)}
        fullWidth={true}
        maxWidth="sm"
      >
        <DialogTitle sx={{ pt: 4, fontWeight: 600 }}>Check-out</DialogTitle>
        <DialogContent>
          <DialogContentText>{checkoutMessage}</DialogContentText>
        </DialogContent>
        <DialogActions sx={{ pb: 3, px: 3 }}>
          <Button onClick={() => setOpenWarningModal(false)} color="primary">
            Cancel
          </Button>
          <Button
            onClick={performCheckout}
            color="primary"
            variant="contained"
            autoFocus
          >
            Yes, Check Out
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
const OvertimeRequestsCard = (props) => {
  const { latestOvertimes } = props;
  const navigate = useNavigate();

  const handleOvertimeView = () => {
    toast.info("Navigate to all overtime requests page.");
  };

  const handleRequestClick = (id) => {
    navigate(`/view-overtime-request/${id}`);
  };

  const navigateToAllOvertime = () => {
    navigate(PATH.ALLOVERTIMEREQUESTS);
  };
  const getStatusIcon = (status) => {
    switch (status) {
      case "Approved":
        return (
          <Tooltip title="Approved">
            <img
              style={{ width: 17, height: 13 }}
              src="/assets/images/approved.svg"
              alt="Approved"
            />
          </Tooltip>
        );
      case "Rejected":
        return (
          <Tooltip title="Rejected">
            <CloseIcon color="error" />
          </Tooltip>
        );
      case "Pending":
      default:
        return (
          <Tooltip title="Pending">
            <HourglassBottomIcon />
          </Tooltip>
        );
    }
  };

  return (
    <Grid item xs={12} sm={6} md={4} sx={{ pr: { xs: 2, sm: 0 } }}>
      <div className="card3-leaves">
        {" "}
        <div className="leave-card" style={{ display: "flex" }}>
          <p
            style={{
              color: "#757878",
              paddingTop: "20px",
              fontWeight: "700",
              paddingLeft: "20px",
            }}
          >
            Overtime Request
          </p>
          <u
            style={{
              paddingRight: "10px",
              paddingTop: "31px",
              cursor: "pointer",
              marginLeft: "auto",
            }}
            // onClick={handleOvertimeView}
            onClick={(e) => {
              e.stopPropagation();
              navigateToAllOvertime();
            }}
          >
            See All
          </u>
        </div>
        <div
          style={{
            overflowY: "auto",
            maxHeight: "200px",
            marginTop: "10px",
          }}
        >
          {(latestOvertimes || []).map((request, index) => (
            <Grid item xs={12} key={index}>
              <div
                className="leave-request"
                onClick={() => navigateToAllOvertime(request.id)}
                style={{
                  margin: "0 10px 10px 10px",
                  display: "flex",
                  paddingTop: "10px",
                  justifyContent: "space-between",
                  cursor: "pointer",
                }}
              >
                <div style={{ flexDirection: "column", lineHeight: "5px" }}>
                  <p className="leave-name" style={{ paddingLeft: "14px" }}>
                    {request?.user?.name || "Unknown User"}
                  </p>
                  <p
                    style={{
                      fontSize: "12px",
                      color: "#757878",
                      paddingLeft: "14px",
                    }}
                  >
                    {request.hours || 0} Hours
                  </p>
                </div>
                <div
                  style={{
                    display: "flex",
                    marginRight: "15px",
                    alignItems: "center",
                  }}
                >
                  {getStatusIcon(request.status)}
                  <p
                    style={{
                      color: "#757878",
                      fontSize: "12px",
                      marginLeft: "8px",
                    }}
                  >
                    Status
                  </p>
                  <img
                    style={{ marginLeft: "8px" }}
                    src="/assets/images/carousel.svg"
                    width={7}
                    height={13}
                    alt=""
                  />
                </div>
              </div>
            </Grid>
          ))}
        </div>
      </div>
    </Grid>
  );
};
export default function Dashboard() {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [stats, setStats] = useState(null);
  const [liveWorkingHoursToday, setLiveWorkingHoursToday] = useState(0);
  const [isNotCheckedInModalOpen, setIsNotCheckedInModalOpen] = useState(false);
  const [notCheckedInUsers, setNotCheckedInUsers] = useState([]);
  const [isModalLoading, setIsModalLoading] = useState(false);
  const [isOnBreakModalOpen, setIsOnBreakModalOpen] = useState(false);
  const [usersOnBreak, setUsersOnBreak] = useState([]);
  const [isBreakModalLoading, setIsBreakModalLoading] = useState(false);

  const [isAnnouncementModalOpen, setIsAnnouncementModalOpen] = useState(false);
  const [selectedAnnouncement, setSelectedAnnouncement] = useState(null);
  const [liveOvertimeHoursToday, setLiveOvertimeHoursToday] = useState(0);
  const auth = useAuth();
  const dispatch = useDispatch();

  const handleOpenAnnouncementModal = (announcement) => {
    setSelectedAnnouncement(announcement);
    setIsAnnouncementModalOpen(true);
  };

  const handleCloseAnnouncementModal = () => {
    setIsAnnouncementModalOpen(false);
    setSelectedAnnouncement(null);
  };

  const fetchDashboardData = () => {
    if (!auth.token) {
      return;
    }
    setLoading(true);
    getDashboard(auth.token)
      .then((resp) => {
        if (resp.data.succeeded === true) {
          setStats(resp.data.data);
        } else {
          toast.error("Failed to load dashboard data. Please try again.");
        }
      })
      .catch((error) => {
        toast.error("An error occurred while loading dashboard data.");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchDashboardData();
  }, [auth.token]);

  useEffect(() => {
    const handleFocus = () => {
      console.log("Window focused, refetching dashboard data...");
      fetchDashboardData();
    };

    window.addEventListener("focus", handleFocus);

    return () => {
      window.removeEventListener("focus", handleFocus);
    };
  }, []);

  useEffect(() => {
    let intervalId;
    const todayDetails = stats?.todayAttendanceDetails;
    const todayOvertimeStatus = stats?.todayOvertimeRequestStatus;

    if (todayDetails && todayDetails.rawCheckIn && !todayDetails.rawCheckOut) {
      intervalId = setInterval(() => {
        const { rawCheckIn, breakTime, isBreak, breakTimeStart } = todayDetails;
        const checkInTime = new Date(rawCheckIn).getTime();
        const now = new Date().getTime();
        const totalDurationMs = now - checkInTime;

        let totalBreakMs = (breakTime || 0) * 1000;
        if (isBreak && breakTimeStart) {
          const currentBreakStartMs = new Date(breakTimeStart).getTime();
          totalBreakMs += now - currentBreakStartMs;
        }

        const workingDurationMs = totalDurationMs - totalBreakMs;
        const workingHoursDecimal = workingDurationMs / (1000 * 60 * 60);

        setLiveWorkingHoursToday(
          workingHoursDecimal > 0 ? workingHoursDecimal : 0
        );

        if (todayOvertimeStatus === "Approved") {
          const standardWorkHours = 8;
          const overtimeHoursDecimal =
            workingHoursDecimal > standardWorkHours
              ? workingHoursDecimal - standardWorkHours
              : 0;
          setLiveOvertimeHoursToday(
            overtimeHoursDecimal > 0 ? overtimeHoursDecimal : 0
          );
        } else {
          setLiveOvertimeHoursToday(0);
        }
      }, 1000);
    } else if (todayDetails && todayDetails.rawCheckOut) {
      clearInterval(intervalId);
      setLiveWorkingHoursToday(stats.workingHours.day || 0);
      setLiveOvertimeHoursToday(stats.overtimeHours.day || 0);
    } else {
      setLiveWorkingHoursToday(0);
      setLiveOvertimeHoursToday(0);
    }

    return () => clearInterval(intervalId);
  }, [stats]);
  const handleOpenNotCheckedInModal = () => {
    console.log("1. Click handler started.");

    if (!stats || stats.todayPendingCheckIns === undefined) {
      toast.error("Dashboard data is not ready yet. Please wait a moment.");
      console.error("2. CRASH AVERTED: stats object is not ready.", stats);
      return;
    }

    console.log("3. Stats object is OK:", stats);

    if (stats.todayPendingCheckIns === 0) {
      toast.info("All employees have checked in today!");
      return;
    }

    console.log("4. Opening modal now...");
    setIsNotCheckedInModalOpen(true);
    setIsModalLoading(true);

    console.log("5. Calling API to get users...");
    getNotCheckedInUsers(auth)
      .then((resp) => {
        console.log("6. API call successful:", resp.data);
        if (resp.data.succeeded) {
          setNotCheckedInUsers(resp.data.data);
        } else {
          toast.error("Could not fetch the list of users.");
        }
      })
      .catch((err) => {
        console.error("7. API call FAILED:", err);
        toast.error("An error occurred while fetching the user list.");
      })
      .finally(() => {
        setIsModalLoading(false);
      });
  };
  const handleCloseNotCheckedInModal = () => {
    setIsNotCheckedInModalOpen(false);
    setNotCheckedInUsers([]);
  };

  const handleLeaveView = () => {
    navigate(PATH.ALLREQUESTS);
  };
  const handleOpenOnBreakModal = () => {
    if (stats.totalOnBreak === 0) {
      toast.info("No employees are currently on break.");
      return;
    }

    setIsOnBreakModalOpen(true);
    setIsBreakModalLoading(true);
    getUsersOnBreak(auth)
      .then((resp) => {
        if (resp.data.succeeded) {
          setUsersOnBreak(resp.data.data);
        } else {
          toast.error("Could not fetch the list of users on break.");
        }
      })
      .catch((err) => {
        toast.error("An error occurred while fetching the user list.");
      })
      .finally(() => {
        setIsBreakModalLoading(false);
      });
  };

  const handleCloseOnBreakModal = () => {
    setIsOnBreakModalOpen(false);
    setUsersOnBreak([]);
  };
  if (loading || !stats) {
    return <Loading />;
  }

  return (
    <div className="main-dashboard">
      <div className="body">
        <ShowAnnouncements onOpen={handleOpenAnnouncementModal}/>

        <div className="container">
          <p style={{ color: "#757878", fontSize: "16px", fontWeight: "700" }}>
            {auth.userType === "admin"
              ? "Attendance Overview "
              : "Profile Overview"}
          </p>
          <span className="line"></span>
        </div>

        {auth.userType === "admin" && (
          <Box
            sx={{
              flexGrow: 1,
              width: "98%",
              pb: 6,
              pr: {
                xs: 2,
              },
            }}
          >
            <Grid
              container
              spacing={2}
              justifyContent={{
                xs: "center",
                sm: "flex-start",
                md: "space-between",
              }}
            >
              {/* CARD 1: Total Employees */}
              <Grid item xs={12} sm={6} md={3}>
                <Box
                  sx={{
                    border: "1px solid #ccc",
                    borderRadius: "8px",
                    p: 2,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                    backgroundColor: "#0072BC",
                  }}
                >
                  <p style={{ marginTop: "1px", color: "white" }}>
                    Total Employees
                  </p>

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      marginTop: "45px",
                      height: "25px",
                    }}
                  >
                    <p style={{ margin: 0, color: "white", fontSize: "40px" }}>
                      {stats?.totalEmployees || 0}
                    </p>
                    <img
                      src="/assets/images/employeeNumber.svg"
                      alt="icon"
                      style={{ width: "43px", height: "43px" }}
                    />
                  </div>
                </Box>
              </Grid>
              {/* CARD 2: Check-In Today */}
              <Grid item xs={12} sm={6} md={3}>
                <Box
                  sx={{
                    border: "1px solid #ccc",
                    borderRadius: "8px",
                    p: 2,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                    backgroundColor: "#fff",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <p style={{ marginTop: "1px", color: "#757878" }}>
                      Check-In Today
                    </p>

                    <div
                      style={{
                        backgroundColor: "#008001",
                        borderRadius: "50%",
                        width: "40px",
                        height: "40px",
                        marginTop: "-16px",
                      }}
                    >
                      <img
                        src="/assets/images/checkin.svg"
                        alt="icon"
                        style={{
                          width: "27px",
                          height: "22px",
                          marginLeft: "6px",
                          marginTop: "8px",
                        }}
                      />
                    </div>
                  </Box>
                  <div style={{ height: "40px", marginTop: "30px" }}>
                    <span
                      style={{
                        margin: 0,
                        color: "#757878",
                        fontSize: "40px",
                      }}
                    >
                      {stats.todayCheckIns || 0}
                      <span style={{ color: "#757878", fontSize: "12px" }}>
                        Employees
                      </span>
                    </span>
                  </div>
                </Box>
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <Box
                  onClick={handleOpenNotCheckedInModal}
                  sx={{
                    cursor: "pointer",
                    border: "1px solid #ccc",
                    borderRadius: "8px",
                    p: 2,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                    backgroundColor: "#fff",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <p style={{ marginTop: "1px", color: "#757878" }}>
                      Not Check-In Today
                    </p>

                    <div
                      style={{
                        backgroundColor: "#C70303",
                        borderRadius: "50%",
                        width: "40px",
                        height: "40px",
                        marginTop: "-16px",
                      }}
                    >
                      <img
                        src="/assets/images/notCheckin.svg"
                        alt="icon"
                        style={{
                          width: "23px",
                          height: "22px",
                          marginLeft: "10px",
                          marginTop: "8px",
                        }}
                      />
                    </div>
                  </Box>
                  <div style={{ height: "40px", marginTop: "30px" }}>
                    <span
                      style={{
                        margin: 0,
                        color: "#757878",
                        fontSize: "40px",
                      }}
                    >
                      {stats.todayPendingCheckIns || 0}
                      <span style={{ color: "#757878", fontSize: "12px" }}>
                        Employees
                      </span>
                    </span>
                  </div>
                </Box>
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <Box
                  onClick={handleOpenOnBreakModal}
                  sx={{
                    cursor: "pointer",
                    border: "1px solid #ccc",
                    borderRadius: "8px",
                    p: 2,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                    backgroundColor: "#fff",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <p style={{ marginTop: "1px", color: "#757878" }}>
                      Currently on Break
                    </p>

                    <div
                      style={{
                        backgroundColor: "#E67B00",
                        borderRadius: "50%",
                        width: "40px",
                        height: "40px",
                        marginTop: "-16px",
                      }}
                    >
                      <img
                        src="/assets/images/break.svg"
                        alt="icon"
                        style={{
                          width: "23px",
                          height: "22px",
                          marginLeft: "8px",
                          marginTop: "8px",
                        }}
                      />
                    </div>
                  </Box>
                  <div style={{ marginTop: "30px", height: "40px" }}>
                    <span
                      style={{
                        margin: 0,
                        color: "#757878",
                        fontSize: "40px",
                      }}
                    >
                      {stats.totalOnBreak || 0}
                      <span style={{ color: "#757878", fontSize: "12px" }}>
                        Employees
                      </span>
                    </span>
                  </div>
                </Box>
              </Grid>

              <Dialog
                open={isOnBreakModalOpen}
                onClose={handleCloseOnBreakModal}
                fullWidth
                maxWidth="xs"
              >
                <DialogTitle sx={{ fontWeight: 600 }}>
                  Employees Currently on Break
                </DialogTitle>
                <DialogContent dividers sx={{ p: 0 }}>
                  {isBreakModalLoading ? (
                    <Box
                      sx={{ display: "flex", justifyContent: "center", my: 3 }}
                    >
                      <CircularProgress />
                    </Box>
                  ) : usersOnBreak.length > 0 ? (
                    <List dense>
                      {usersOnBreak.map((user, index) => (
                        <React.Fragment key={user.id}>
                          <ListItem sx={{ py: 1.5 }}>
                            <ListItemText
                              primary={
                                <Box
                                  component="span"
                                  sx={{ display: "flex", alignItems: "center" }}
                                >
                                  <Typography variant="body1">
                                    {user.name}
                                  </Typography>
                                  {user.deviceId && (
                                    <Typography
                                      variant="body2"
                                      color="text.secondary"
                                      sx={{ ml: 1 }}
                                    >
                                      ({user.deviceId})
                                    </Typography>
                                  )}
                                </Box>
                              }
                              secondary={
                                <Box
                                  component="span"
                                  sx={{ display: "block", mt: 0.5 }}
                                >
                                  <Typography
                                    component="span"
                                    variant="body2"
                                    color="text.secondary"
                                  >
                                    Checked In:{" "}
                                    {formatTimeForDisplay(user.checkInTime)}
                                  </Typography>
                                  <br />
                                  <Typography
                                    component="span"
                                    variant="body2"
                                    color="text.secondary"
                                  >
                                    Total Break:{" "}
                                    {formatBreakDuration(
                                      user.totalBreakSeconds
                                    )}
                                  </Typography>
                                </Box>
                              }
                            />
                          </ListItem>
                          {index < usersOnBreak.length - 1 && (
                            <Divider component="li" />
                          )}
                        </React.Fragment>
                      ))}
                    </List>
                  ) : (
                    <DialogContentText sx={{ textAlign: "center", my: 3 }}>
                      No employees are on break right now.
                    </DialogContentText>
                  )}
                </DialogContent>
                <DialogActions>
                  <Button onClick={handleCloseOnBreakModal}>Close</Button>
                </DialogActions>
              </Dialog>
            </Grid>
          </Box>
        )}

        {(auth.userType === "employee" || auth.userType === "teamlead") && (
          <div style={{ marginBottom: "30px" }}>
            <Grid container spacing={2} sx={{ width: "98%" }}>
              <Grid item xs={12} sm={6} md={3}>
                <StatusCard
                  stats={stats}
                  onStatusChange={fetchDashboardData}
                  liveWorkingHoursToday={liveWorkingHoursToday}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <BreakCard
                  todayAttendanceDetails={stats?.todayAttendanceDetails}
                  onBreakToggle={fetchDashboardData}
                  isUserCheckedOut={
                    stats?.todayAttendanceDetails?.rawCheckOut !== null
                  }
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <WorkingHoursCard
                  workingHours={stats?.workingHours}
                  liveWorkingHoursToday={liveWorkingHoursToday}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <OvertimeCard
                  overtimeHours={stats?.overtimeHours}
                  liveWorkingHoursToday={liveWorkingHoursToday}
                  liveOvertimeHoursToday={liveOvertimeHoursToday}
                />
              </Grid>
            </Grid>
          </div>
        )}
        <div
          className="admin-announcements"
          style={{
            marginTop: "13px",
            justifyContent: "space-between",
            width: "97%",
          }}
        >
          {auth.userType === "admin" && (
            <Grid container spacing={2} justifyContent="space-between">
              <UpcommingHolidays upcomingHolidays={stats?.upcomingHolidays} />

              {/* <OvertimeRequestsCard latestOvertimes={stats?.latestOvertimes} /> */}
              <OvertimeRequestsCard latestOvertimes={stats?.latestOvertimes} />
              <Grid item xs={12} sm={6} md={4} sx={{ pr: { xs: 2, sm: 0 } }}>
                <div className="card3-leaves">
                  <div className="leave-card" style={{ display: "flex" }}>
                    <p
                      style={{
                        color: "#757878",
                        paddingTop: "20px",
                        fontWeight: "700",
                        paddingLeft: "20px",
                      }}
                    >
                      Leave Requests
                    </p>
                    <u
                      style={{
                        paddingRight: "10px",
                        paddingTop: "31px",
                        paddingBottom: "5px",
                        cursor: "pointer",
                        marginLeft: "auto",
                      }}
                      onClick={handleLeaveView}
                    >
                      See All
                    </u>
                  </div>
                  <div
                    style={{
                      overflowY: "auto",
                      maxHeight: "200px",
                      marginTop: "10px",
                    }}
                  >
                    {(stats?.latestLeaves || []).map((leave, index) => (
                      <Grid item xs={12} key={index}>
                        <div
                          className="leave-request"
                          style={{
                            margin: "0 10px 10px 10px",
                            display: "flex",
                            paddingTop: "10px",
                            justifyContent: "space-between",
                          }}
                        >
                          <div
                            style={{
                              flexDirection: "column",
                              lineHeight: "5px",
                            }}
                          >
                            <p
                              className="leave-name"
                              style={{ paddingLeft: "14px" }}
                            >
                              {leave?.user?.name || "Unknown User"}
                            </p>
                            <p
                              style={{
                                fontSize: "12px",
                                color: "#757878",
                                paddingLeft: "14px",
                              }}
                            >
                              No. of Days: {leave.numberOfDays || 0}
                            </p>
                          </div>
                          <div
                            style={{
                              display: "flex",
                              marginRight: "15px",
                              alignItems: "center",
                            }}
                          >
                            {leave.status === "Pending" ? (
                              <Tooltip title="Pending">
                                <HourglassBottomIcon />
                              </Tooltip>
                            ) : leave.status === "Approved" ? (
                              <Tooltip title="Approved">
                                <img
                                  style={{ width: 17, height: 13 }}
                                  src="/assets/images/approved.svg"
                                  alt="Approved"
                                />
                              </Tooltip>
                            ) : (
                              <Tooltip title="Rejected">
                                <CloseIcon color="error" />
                              </Tooltip>
                            )}
                            <p
                              style={{
                                color: "#757878",
                                fontSize: "16px",
                                marginLeft: "8px",
                              }}
                            >
                              Status
                            </p>
                            <img
                              style={{ marginLeft: "8px" }}
                              src="/assets/images/carousel.svg"
                              width={7}
                              height={13}
                              alt=""
                            />
                          </div>
                        </div>
                      </Grid>
                    ))}
                  </div>
                </div>
              </Grid>
            </Grid>
          )}

          {(auth.userType === "employee" || auth.userType === "teamlead") && (
            <Grid container spacing={2} justifyContent="space-between">
              <UpcommingHolidays upcomingHolidays={stats?.upcomingHolidays} />
              <Announcements
                announcements={stats?.announcements}
                onAnnouncementClick={handleOpenAnnouncementModal}
              />
              <LeavesCard leaveBalance={stats.leaveBalance} />
            </Grid>
          )}
        </div>

        <WeeklyCheckinOut
          attandance={
            auth.userType === "admin"
              ? stats?.todayAttendance
              : stats?.weeklyAttendance
          }
        />
        <Dialog
          open={isNotCheckedInModalOpen}
          onClose={handleCloseNotCheckedInModal}
          fullWidth
          maxWidth="xs"
        >
          <DialogTitle sx={{ fontWeight: 600 }}>
            Employees Not Checked-In Today
          </DialogTitle>
          <DialogContent dividers>
            {isModalLoading ? (
              <Box sx={{ display: "flex", justifyContent: "center", my: 3 }}>
                <CircularProgress />
              </Box>
            ) : notCheckedInUsers.length > 0 ? (
              <List dense>
                {notCheckedInUsers.map((user) => (
                  <ListItem key={user.id}>
                    <ListItemText primary={user.name} secondary={user.email} />
                  </ListItem>
                ))}
              </List>
            ) : (
              <DialogContentText sx={{ textAlign: "center", my: 3 }}>
                All applicable employees have checked in today.
              </DialogContentText>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseNotCheckedInModal}>Close</Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={isAnnouncementModalOpen}
          onClose={handleCloseAnnouncementModal}
          fullWidth
          maxWidth="sm"
        >
          <DialogTitle sx={{ fontWeight: 600 }}>
            {selectedAnnouncement?.title}
          </DialogTitle>
          <DialogContent dividers>
            <DialogContentText
              style={{ whiteSpace: "pre-wrap", color: "rgba(0, 0, 0, 0.87)" }}
            >
              {selectedAnnouncement?.message}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseAnnouncementModal}>Close</Button>
          </DialogActions>
        </Dialog>
      </div>
    </div>
  );
}


const CardAnnouncement = ({ annoucement, setAnnoucements, onOpen }) => {
  let auth = useAuth();
 
  const handleClose = (e) => {
    e.stopPropagation();
    dismissUserAnnouncements(annoucement.id, auth.token).then(
      (res) => {
        if (res.data.succeeded === true) {
          setAnnoucements((prev) =>
            prev.filter((a) => a.id !== annoucement.id)
          );
        }
      },
      (error) => {
      }
    );
  };
 
  const announcementConfig = {
    general: {
      color: "#F0F0F0",
      icon: <Notifications sx={{ color: "#0072BC", marginRight: 1, fontSize: "18px" }} />,
    },
    Holiday: {
      color: "#2ecc71",
      icon: <HolidayVillage sx={{ color: "white", marginRight: 1, fontSize: "18px" }} />,
    },
    Event: {
      color: "#f39c12",
      icon: <EventAvailable sx={{ color: "white", marginRight: 1, fontSize: "18px" }} />,
    },
    Urgent: {
      color: "#e74c3c",
      icon: <Error sx={{ color: "white", marginRight: 1, fontSize: "18px" }} />,
    },
  };
 
  const { color, icon } =
    announcementConfig[annoucement.type] || announcementConfig.general;
 
  return (
    <Box
      className="employee-month"
      onClick={() => onOpen(annoucement)}
      sx={{
        position: "relative",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "flex-start",
        padding: "15px",
        boxSizing: "border-box",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: 10,
          right: 10,
          cursor: "pointer",
          zIndex: 10,
          padding: "5px",
          transition: "0.2s",
          "&:hover": { opacity: 0.7 }
        }}
        onClick={handleClose}
      >
        <img
          width={12}
          height={12}
          src="/assets/images/closeButton.svg"
          alt="close button"
        />
      </Box>
 
      <Box sx={{ marginTop: "5px", marginBottom: "10px" }}>
        <Typography
          variant="subtitle2"
          sx={{
            backgroundColor: color,
            color: annoucement.type === "general" ? "#0072BC" : "white",
            padding: "4px 12px",
            borderRadius: "20px",
            display: "inline-flex",
            alignItems: "center",
            fontSize: "12px",
            fontWeight: "600",
            textTransform: "capitalize",
            whiteSpace: "nowrap"
          }}
        >
          {icon}
          {capitalizeFirstLetter(annoucement.type)} Announcement
        </Typography>
      </Box>
 
      <Typography
        variant="h6"
        sx={{
          color: "#323232",
          fontWeight: "700",
          fontSize: "18px",
          textAlign: "center",
          marginBottom: "8px",
          width: "100%",
          paddingX: "10px",
          display: "-webkit-box",
          WebkitBoxOrient: "vertical",
          WebkitLineClamp: 1,
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
        title={annoucement.title}
      >
        {capitalizeFirstLetter(annoucement.title)}
      </Typography>
 
      <Typography
        sx={{
          color: "#757878",
          fontSize: "13px",
          lineHeight: "1.5",
          textAlign: "center",
          width: "100%",
          paddingX: "5px",
          display: "-webkit-box",
          WebkitBoxOrient: "vertical",
          WebkitLineClamp: 3,
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        {annoucement.message}
      </Typography>
    </Box>
  );
};
 
const ShowAnnouncements = ({ onOpen }) => {
  const auth = useAuth();
  const [annoucements, setAnnoucements] = useState([]);
 
  useEffect(() => {
    if (auth.userType !== "admin") {
      getUserAnnouncements(auth.token).then(
        (res) => {
          if (res.data.succeeded === true) {
            setAnnoucements(res.data.data);
          }
        },
        (error) => {}
      );
    }
  }, [auth.token]);
 
  return (
    <div>
      {(annoucements || []).map((ann, index) => {
        return (
          <CardAnnouncement
            setAnnoucements={setAnnoucements}
            annoucement={ann}
            annoucements={annoucements}
            onOpen={onOpen}
            key={index}
          />
        );
      })}
    </div>
  );
};
const BreakCard = (props) => {
  const { todayAttendanceDetails, onBreakToggle, isUserCheckedOut } = props;
  const dispatch = useDispatch();
  const [stopwatchSeconds, setStopwatchSeconds] = useState(0);
  const [isOnBreak, setIsOnBreak] = useState(false);
  const [isToggling, setIsToggling] = useState(false);
  const intervalRef = useRef(null);

  useEffect(() => {
    clearInterval(intervalRef.current);
    const isBreakActive = todayAttendanceDetails?.isBreak ?? false;
    const accumulatedBreakSeconds = todayAttendanceDetails?.breakTime || 0;
    setIsOnBreak(isBreakActive);
    if (isBreakActive && todayAttendanceDetails.breakTimeStart) {
      const breakStartTime = new Date(
        todayAttendanceDetails.breakTimeStart
      ).getTime();
      const updateStopwatch = () => {
        const now = new Date().getTime();
        const elapsedSeconds = Math.floor((now - breakStartTime) / 1000);
        setStopwatchSeconds(accumulatedBreakSeconds + elapsedSeconds);
      };
      updateStopwatch();
      intervalRef.current = setInterval(updateStopwatch, 1000);
    } else {
      setStopwatchSeconds(accumulatedBreakSeconds);
    }
    return () => clearInterval(intervalRef.current);
  }, [todayAttendanceDetails]);

  const handleToggleBreak = () => {
    if (isUserCheckedOut) {
      toast.info("You cannot manage break after checking out.");
      return;
    }
    if (!todayAttendanceDetails) {
      toast.error("Please check-in first to start a break.");
      return;
    }
    if (isToggling) return;
    setIsToggling(true);
    const action = isOnBreak ? dispatch(endBreak()) : dispatch(startBreak());
    action
      .then(() => {
        if (onBreakToggle) onBreakToggle();
      })
      .catch(() => {})
      .finally(() => setIsToggling(false));
  };

  const formatTime = (totalSeconds) => {
    if (!totalSeconds || isNaN(totalSeconds) || totalSeconds < 0)
      return "00:00:00";
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
      2,
      "0"
    )}:${String(seconds).padStart(2, "0")}`;
  };

  return (
    <Box
      sx={{
        border: "1px solid #ccc",
        borderRadius: "8px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        height: "150px",
        boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
        backgroundColor: "#ffffff",
        padding: "20px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography sx={{ fontSize: "16px", color: "#757878" }}>
          Break
        </Typography>

        <Typography sx={{ fontSize: "14px", color: "#323232" }}>
          {isUserCheckedOut ? "N/A" : isOnBreak ? "On Break" : "Not On Break"}
        </Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-end",
          mt: -2,
        }}
      >
        <Typography variant="h5" sx={{ color: "#323232" }}>
          {formatTime(stopwatchSeconds)}
        </Typography>
        <Switch
          checked={isOnBreak}
          onChange={handleToggleBreak}
          disabled={isToggling || isUserCheckedOut || !todayAttendanceDetails}
        />
      </Box>
    </Box>
  );
};

const LeavesCard = (props) => {
  const { leaveBalance } = props;
  const navigate = useNavigate();

  const handleLeaveApply = () => {
    navigate(PATH.CREATEREQUEST);
  };
  return (
    <Grid
      item
      xs={12}
      sm={6}
      md={4}
      sx={{
        pr: { xs: 2, sm: 0 },
      }}
    >
      <div className="card3-leaves">
        <div className="leave-card-employee" style={{ display: "flex" }}>
          <div style={{ lineHeight: "5px" }}>
            <p
              style={{
                color: "#757878",
                paddingTop: "18px",
                fontWeight: "700",
                paddingLeft: "20px",
              }}
            >
              Leaves
            </p>
            <p
              style={{
                paddingLeft: "20px",
                color: "#757878",
                fontSize: "14px",
              }}
            >
              21 Days per Annum
            </p>
          </div>
          <div className="leave-request-btn">
            <p onClick={handleLeaveApply}>Apply Now</p>
          </div>
        </div>
        <div
          style={{
            overflowY: "auto",
            maxHeight: "200px",
            paddingRight: "10px",
            paddingLeft: "10px",
          }}
        >
          <div className="leave-request-employee" style={{ marginTop: "20px" }}>
            <div className="leave-name">
              <p>Sick</p>
            </div>
            <div className="leave-status">
              <p>{`${leaveBalance?.sickLeaves || 0}/07`}</p>
            </div>
          </div>

          <div className="leave-request-employee" style={{ marginTop: "10px" }}>
            <div className="leave-name">
              <p>Casual</p>
            </div>
            <div className="leave-status">
              <p>{`${leaveBalance?.casualLeaves || 0}/07`}</p>
            </div>
          </div>

          <div className="leave-request-employee" style={{ marginTop: "10px" }}>
            <div className="leave-name">
              <p>Urgent</p>
            </div>
            <div className="leave-status">
              <p>{`${leaveBalance?.urgentLeaves || 0}/07`}</p>
            </div>
          </div>

          <div className="leave-request-employee" style={{ marginTop: "10px" }}>
            <div className="leave-name">
              <p>Un-Paid</p>
            </div>
            <div className="leave-status">
              <p>{`${leaveBalance?.unPaid || 0}`}</p>
            </div>
          </div>
        </div>
      </div>
    </Grid>
  );
};

const UpcommingHolidays = (props) => {
  const { upcomingHolidays } = props;
  return (
    <Grid
      item
      xs={12}
      sm={6}
      md={4}
      sx={{
        pr: { xs: 2, sm: 0 },
      }}
    >
      <div className="card1-holiday">
        <p
          style={{
            color: "#757878",
            paddingLeft: "20px",
            paddingTop: "20px",
            paddingBottom: "5px",
            fontWeight: "700",
          }}
        >
          Upcoming Holidays!
        </p>
        <TableContainer
          component={Paper}
          sx={{
            overflowY: "auto",
            flexGrow: 1,
            boxShadow: "none",
            maxHeight: "200px",
            borderRadius: "0 0 0 0",
          }}
        >
          <Table>
            <TableHead>
              <TableRow style={{ backgroundColor: "#E6EAED" }}>
                <TableCell
                  style={{
                    color: "#757878",
                    paddingLeft: "20px",
                    fontWeight: "700",
                    width: "35%",
                  }}
                >
                  Start Date
                </TableCell>
                <TableCell
                  style={{
                    color: "#757878",
                    paddingLeft: "20px",
                    fontWeight: "700",
                    width: "35%",
                  }}
                >
                  End Date
                </TableCell>
                <TableCell
                  style={{
                    color: "#757878",
                    fontWeight: "700",
                    paddingLeft: "20px",
                    width: "30%",
                  }}
                >
                  Holiday
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {(upcomingHolidays || []).map((holiday, index) => {
                const displayEndDate =
                  holiday.endDate !== holiday.startDate ? holiday.endDate : "-";
                return (
                  <TableRow key={index}>
                    <TableCell
                      style={{ color: "#757878", paddingLeft: "20px" }}
                    >
                      {holiday.startDate}
                    </TableCell>
                    <TableCell
                      style={{ color: "#757878", paddingLeft: "20px" }}
                    >
                      {displayEndDate}
                    </TableCell>
                    <TableCell
                      style={{ color: "#757878", paddingLeft: "20px" }}
                    >
                      {holiday.title}
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </Grid>
  );
};

const Announcements = (props) => {
  const { announcements, onAnnouncementClick } = props;
  return (
    <Grid
      item
      xs={12}
      sm={6}
      md={4}
      sx={{
        pr: { xs: 2, sm: 0 },
      }}
    >
      <div className="card1-holiday">
        <div style={{ display: "flex", gap: "10px" }}>
          <img
            style={{
              paddingLeft: "20px",
              paddingTop: "20px",
              paddingBottom: "5px",
            }}
            src="/assets/images/annoucementIcon.svg"
            alt=""
          />
          <p
            style={{ color: "#757878", paddingTop: "20px", fontWeight: "700" }}
          >
            Announcements
          </p>
        </div>
        <div
          style={{
            overflowY: "auto",
            maxHeight: "200px",
            marginTop: "10px",
          }}
        >
          {(announcements || []).map((ancmnt, index) => {
            return (
              <Grid item sm={12} md="auto" key={index}>
                <div style={{ paddingLeft: "10px", paddingRight: "10px" }}>
                  <div
                    className="announcement-2"
                    style={{
                      alignItems: "center",
                      display: "flex",
                      justifyContent: "space-between",
                      marginBottom: "10px",
                      cursor: "pointer",
                    }}
                    onClick={() => onAnnouncementClick(ancmnt)}
                  >
                    <p
                      style={{
                        paddingLeft: "14px",
                        display: "-webkit-box",
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: "vertical",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        paddingTop: "13px",
                        margin: 0,
                        lineHeight: "1.2em",
                      }}
                    >
                      {ancmnt.title}
                    </p>

                    <img
                      style={{ marginTop: "17px", marginRight: "10px" }}
                      src="/assets/images/carousel.svg"
                      width={7}
                      height={13}
                      alt=""
                    />
                  </div>
                </div>
              </Grid>
            );
          })}
        </div>
      </div>
    </Grid>
  );
};

const WorkingHoursCard = ({ workingHours, liveWorkingHoursToday }) => {
  const [filter, setFilter] = useState("day");
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  function decimalToTime(hoursDecimal) {
    if (isNaN(hoursDecimal) || hoursDecimal < 0) return "00:00";
    const totalMinutes = Math.floor(hoursDecimal * 60);
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
      2,
      "0"
    )}`;
  }

  const displayHours = () => {
    const initialToday = workingHours?.day || 0;
    switch (filter) {
      case "day":
        return liveWorkingHoursToday || 0;
      case "week":
        return (workingHours?.week || 0) - initialToday + liveWorkingHoursToday;
      case "month":
        return (
          (workingHours?.month || 0) - initialToday + liveWorkingHoursToday
        );
      default:
        return workingHours?.day || 0;
    }
  };

  return (
    <Box
      sx={{
        border: "1px solid #ccc",
        borderRadius: "8px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        height: "150px",
        boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
        backgroundColor: "#ffffff",
        padding: "16px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography sx={{ color: "#757878", fontSize: "16px" }}>
          Working Hours
        </Typography>
        <div ref={dropdownRef} style={{ position: "relative" }}>
          <Button
            size="small"
            onClick={() => setShowDropdown(!showDropdown)}
            sx={{ textTransform: "capitalize", color: "#757878" }}
            endIcon={
              <img
                width={10}
                height={10}
                src="/assets/images/carousel-down.svg"
                alt="v"
              />
            }
          >
            {filter === "day" ? "Daily" : filter}
          </Button>
          {showDropdown && (
            <Paper
              sx={{ position: "absolute", top: "30px", right: 0, zIndex: 10 }}
            >
              {["day", "week", "month"].map((option) => (
                <ListItem
                  button
                  key={option}
                  onClick={() => {
                    setFilter(option);
                    setShowDropdown(false);
                  }}
                >
                  <ListItemText
                    primary={
                      option === "day"
                        ? "Daily"
                        : option.charAt(0).toUpperCase() + option.slice(1)
                    }
                  />
                </ListItem>
              ))}
            </Paper>
          )}
        </div>
      </Box>
      <Box sx={{ mt: 3 }}>
        <Typography variant="h5" sx={{ color: "#323232" }}>
          {decimalToTime(displayHours())}
        </Typography>
      </Box>
    </Box>
  );
};

const OvertimeCard = ({
  overtimeHours,
  liveWorkingHoursToday,
  liveOvertimeHoursToday,
}) => {
  const dispatch = useDispatch();
  const [filter, setFilter] = useState("day");
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);

  const [open, setOpen] = useState(false);
  const [hours, setHours] = useState("");
  const [reason, setReason] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    setHours("");
    setReason("");
  };

  const handleSubmit = () => {
    if (!reason.trim()) {
      toast.error("Please provide a reason for overtime.");
      return;
    }
    setIsSubmitting(true);
    dispatch(createOvertimeRequest({ reason }))
      .then(() => {
        handleClose();
      })
      .catch((error) => {
        console.error("Overtime request failed:", error);
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };
  function decimalToTime(hoursDecimal) {
    if (isNaN(hoursDecimal) || hoursDecimal < 0) return "00:00";
    const totalMinutes = Math.floor(hoursDecimal * 60);
    const h = Math.floor(totalMinutes / 60);
    const m = totalMinutes % 60;
    return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`;
  }

  // const displayHours = () => {
  //   switch (filter) {
  //     case "day":
  //       return overtimeHours?.day || 0;
  //     case "week":
  //       return overtimeHours?.week || 0;
  //     case "month":
  //       return overtimeHours?.month || 0;
  //     default:
  //       return overtimeHours?.day || 0;
  //   }
  // };
  const displayHours = () => {
    // This is the approved overtime for today fetched from the DB
    const approvedToday = overtimeHours?.day || 0;

    // The live counter shows the potential overtime being worked right now
    const currentLiveOvertime = liveOvertimeHoursToday || 0;

    switch (filter) {
      case "day":
        // For 'Daily', show the live overtime counter
        return currentLiveOvertime;
      case "week":
        // For 'Weekly', show total approved for the week (minus today's approved) + today's live counter
        return (overtimeHours?.week || 0) - approvedToday + currentLiveOvertime;
      case "month":
        // For 'Monthly', show total approved for the month (minus today's approved) + today's live counter
        return (
          (overtimeHours?.month || 0) - approvedToday + currentLiveOvertime
        );
      default:
        return currentLiveOvertime;
    }
  };
  const canRequestOvertime = liveWorkingHoursToday >= 8;

  return (
    <>
      <Box
        sx={{
          border: "1px solid #ccc",
          borderRadius: "8px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          height: "150px",
          boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
          backgroundColor: "#ffffff",
          padding: "16px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography sx={{ color: "#757878", fontSize: "16px" }}>
            Overtime
          </Typography>
          <div ref={dropdownRef} style={{ position: "relative" }}>
            <Button
              size="small"
              onClick={() => setShowDropdown(!showDropdown)}
              sx={{ textTransform: "capitalize", color: "#757878" }}
              endIcon={
                <img
                  width={10}
                  height={10}
                  src="/assets/images/carousel-down.svg"
                  alt="v"
                />
              }
            >
              {filter === "day" ? "Daily" : filter}
            </Button>
            {showDropdown && (
              <Paper
                sx={{ position: "absolute", top: "30px", right: 0, zIndex: 10 }}
              >
                {["day", "week", "month"].map((option) => (
                  <ListItem
                    button
                    key={option}
                    onClick={() => {
                      setFilter(option);
                      setShowDropdown(false);
                    }}
                  >
                    <ListItemText
                      primary={
                        option === "day"
                          ? "Daily"
                          : option.charAt(0).toUpperCase() + option.slice(1)
                      }
                    />
                  </ListItem>
                ))}
              </Paper>
            )}
          </div>
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-end",
          }}
        >
          <Typography variant="h5" sx={{ color: "#323232" }}>
            {decimalToTime(displayHours())}
          </Typography>
          <Tooltip
            title={
              !canRequestOvertime
                ? "You can request overtime after completing 8 working hours."
                : ""
            }
          >
            <span>
              <Button
                variant="contained"
                onClick={handleOpen}
                sx={{ borderRadius: "8px" }}
                disabled={!canRequestOvertime}
              >
                Request
              </Button>
            </span>
          </Tooltip>
        </Box>
      </Box>

      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
        <DialogTitle>Request Overtime</DialogTitle>
        <DialogContent>
          <DialogContentText sx={{ mb: 2 }}>
            Please provide a reason to request overtime approval. Your extra
            working hours will be calculated automatically upon approval.
          </DialogContentText>

          <TextField
            autoFocus
            margin="dense"
            id="reason"
            label="Reason"
            type="text"
            fullWidth
            multiline
            rows={4}
            variant="outlined"
            value={reason}
            onChange={(e) => setReason(e.target.value)}
          />
        </DialogContent>
        <DialogActions sx={{ p: 3 }}>
          <Button onClick={handleClose}>Cancel</Button>
          <Button
            onClick={handleSubmit}
            variant="contained"
            disabled={isSubmitting}
          >
            {isSubmitting ? <CircularProgress size={24} /> : "Submit Request"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

const HorizontalTable = styled.div`
  overflow-x: auto;
  @media (max-width: 600px) {
    width: 260%;
    overflow-x: auto;
  }
`;
const WeeklyCheckinOut = (props) => {
  const { attandance } = props;
  const auth = useAuth();
  const isAdmin = auth.userType === "admin";

  const formatBreakTimeForAdmin = (totalSeconds) => {
    if (!totalSeconds || isNaN(totalSeconds) || totalSeconds <= 0) {
      return "0 min 0 sec";
    }
    if (totalSeconds >= 3600) {
      const hours = Math.floor(totalSeconds / 3600);
      const remainingMinutes = Math.floor((totalSeconds % 3600) / 60);
      return `${hours} hr ${remainingMinutes} min`;
    } else {
      const minutes = Math.floor(totalSeconds / 60);
      const seconds = totalSeconds % 60;
      return `${minutes} min ${seconds} sec`;
    }
  };

  const formatBreakTimeToHHMM = (totalSeconds) => {
    if (!totalSeconds || isNaN(totalSeconds) || totalSeconds < 0)
      return "00:00";
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
      2,
      "0"
    )}`;
  };

  function decimalToTime(workingHours) {
    const hoursDecimal = parseFloat(workingHours);
    if (isNaN(hoursDecimal) || hoursDecimal < 0) {
      return "00:00";
    }
    const totalMinutes = Math.floor(hoursDecimal * 60);
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    const formattedHours = String(hours).padStart(2, "0");
    const formattedMinutes = String(minutes).padStart(2, "0");
    return `${formattedHours}:${formattedMinutes}`;
  }

  return (
    <div style={{ paddingBottom: "10px", marginRight: "18px" }}>
      <div className="check-in-out">
        <p
          style={{
            color: "#757878",
            fontSize: "16px",
            fontWeight: "700",
            paddingTop: "30px",
            paddingLeft: "20px",
            marginBottom: "0px",
          }}
        >
          {`${isAdmin ? "Today's" : "Weekly"} Check In/Out`}
        </p>
        <Box
          padding={2}
          sx={{
            flexGrow: 1,
            overflow: "auto",
            paddingBottom: "30px",
            paddingLeft: "0px",
            paddingRight: "0px",
          }}
        >
          <HorizontalTable>
            <TableContainer component={Paper}>
              <Table>
                {isAdmin ? (
                  <>
                    <TableHead>
                      <TableRow style={{ backgroundColor: "#E6EAED" }}>
                        <TableCell
                          style={{
                            color: "#757878",
                            paddingLeft: "20px",
                            fontWeight: "700",
                          }}
                        >
                          Name
                        </TableCell>
                        <TableCell
                          style={{
                            color: "#757878",
                            fontWeight: "700",
                            paddingLeft: "10px",
                          }}
                        >
                          Check In
                        </TableCell>
                        <TableCell
                          style={{
                            color: "#757878",
                            fontWeight: "700",
                            paddingLeft: "10px",
                          }}
                        >
                          Check Out
                        </TableCell>
                        <TableCell
                          style={{
                            color: "#757878",
                            fontWeight: "700",
                            paddingLeft: "10px",
                          }}
                        >
                          Total Break
                        </TableCell>
                        <TableCell
                          style={{
                            color: "#757878",
                            fontWeight: "700",
                            paddingLeft: "10px",
                          }}
                        >
                          Working Hours
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {(attandance || []).map((att, index) => (
                        <TableRow key={index}>
                          <TableCell
                            style={{ color: "black", paddingLeft: "20px" }}
                          >
                            {att?.user?.name || "-"}
                          </TableCell>
                          <TableCell
                            style={{ color: "black", paddingLeft: "10px" }}
                          >
                            {att?.rawCheckIn
                              ? dayjs(att.rawCheckIn).format(
                                  "YYYY-MM-DD hh:mm A"
                                )
                              : "-"}
                          </TableCell>
                          <TableCell
                            style={{ color: "black", paddingLeft: "10px" }}
                          >
                            {att?.rawCheckOut
                              ? dayjs(att.rawCheckOut).format(
                                  "YYYY-MM-DD hh:mm A"
                                )
                              : "-"}
                          </TableCell>
                          <TableCell
                            style={{ color: "black", paddingLeft: "10px" }}
                          >
                            {formatBreakTimeForAdmin(att?.breakTime)}
                          </TableCell>
                          <TableCell
                            style={{ color: "black", paddingLeft: "10px" }}
                          >
                            {decimalToTime(att?.workingHours) || "-"}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </>
                ) : (
                  <>
                    <TableHead>
                      <TableRow style={{ backgroundColor: "#E6EAED" }}>
                        <TableCell
                          style={{
                            color: "#757878",
                            paddingLeft: "20px",
                            fontWeight: "700",
                          }}
                        >
                          Date & Day
                        </TableCell>
                        <TableCell
                          style={{
                            color: "#757878",
                            fontWeight: "700",
                            paddingLeft: "10px",
                          }}
                        >
                          Check-In
                        </TableCell>
                        <TableCell
                          style={{
                            color: "#757878",
                            fontWeight: "700",
                            paddingLeft: "10px",
                          }}
                        >
                          Check-Out
                        </TableCell>
                        <TableCell
                          style={{
                            color: "#757878",
                            fontWeight: "700",
                            paddingLeft: "10px",
                          }}
                        >
                          Total Break
                        </TableCell>
                        <TableCell
                          style={{
                            color: "#757878",
                            fontWeight: "700",
                            paddingLeft: "10px",
                          }}
                        >
                          Working Hours
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {(attandance || []).map((att, index) => (
                        <TableRow key={index}>
                          <TableCell
                            style={{ color: "black", paddingLeft: "20px" }}
                          >
                            {att.date
                              ? dayjs(att.date).format("DD-MM-YYYY, dddd")
                              : "-"}
                          </TableCell>
                          <TableCell
                            style={{ color: "black", paddingLeft: "10px" }}
                          >
                            {att.checkIn
                              ? dayjs(att.rawCheckIn).format("hh:mm A")
                              : "-"}
                          </TableCell>
                          <TableCell
                            style={{ color: "black", paddingLeft: "10px" }}
                          >
                            {att.checkOut
                              ? dayjs(att.rawCheckOut).format("hh:mm A")
                              : "-"}
                          </TableCell>
                          <TableCell
                            style={{ color: "black", paddingLeft: "10px" }}
                          >
                            {formatBreakTimeToHHMM(att.breakTime)}
                          </TableCell>
                          <TableCell
                            style={{ color: "black", paddingLeft: "10px" }}
                          >
                            {decimalToTime(att.workingHours)}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </>
                )}
              </Table>
            </TableContainer>
          </HorizontalTable>
        </Box>
      </div>
    </div>
  );
};
